import { Children, useEffect, useState } from "react";
import {
  Fade,
  Flip,
  Hinge,
  Roll,
  Rotate,
  Slide,
  Zoom,
} from "react-awesome-reveal";

const Div = ({ children, ...rest }: { [key: string]: any }) => (
  <div {...rest}>{children}</div>
);

export type TApplicationRevealProps = {
  [x: string]: any;
  children: any;
  type?:
    | "fade"
    | "rotate"
    | "zoom"
    | "slide"
    | "roll"
    | "flip"
    | "hinge"
    | "none"
    | undefined;
  reverse?: boolean;
};

const ApplicationReveal = (props: TApplicationRevealProps) => {
  const [hide, setHide] = useState(false);

  const { children, type, ...rest } = props;
  const animationProps = {
    duration: 800,
    delay: 200,
    damping: 0.2,
    triggerOnce: true,
    fraction: 0,
    cascade: true,
    ...rest,
  };

  useEffect(() => {
    if (props.reverse) {
      const totalAnimationDuration =
        animationProps.delay + animationProps.duration;
      setTimeout(() => {
        setHide(true);
      }, totalAnimationDuration);
    } else {
      setHide(false);
    }
  }, [animationProps.delay, animationProps.duration, props.reverse]);

  if (hide) return <></>;

  // if(true) {
  if (type === "none") {
    if (animationProps.cascade) {
      return Children.map(children, (child) => <Div {...props}>{child}</Div>);
    } else {
      return <Div {...props}>{children}</Div>;
    }
  }
  const Component =
    type === "fade"
      ? Fade
      : type === "rotate"
      ? Rotate
      : type === "slide"
      ? Slide
      : type === "roll"
      ? Roll
      : type === "flip"
      ? Flip
      : type === "hinge"
      ? Hinge
      : Zoom;

  return <Component {...animationProps}>{children}</Component>;
};

export default ApplicationReveal;
